// Shared helpers for the subcontractor partner form

const MAX_FILE_BYTES = 3 * 1024 * 1024; // 3 MB per file

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    if (!file) return resolve(null);
    if (file.size > MAX_FILE_BYTES) {
      return reject(new Error(`File "${file.name}" is ${(file.size / 1024 / 1024).toFixed(1)}MB — must be under 3MB. Please compress or split.`));
    }
    const reader = new FileReader();
    reader.onload = () => {
      resolve({
        filename: file.name,
        content_type: file.type || "application/octet-stream",
        size: file.size,
        data_url: reader.result,
      });
    };
    reader.onerror = () => reject(new Error(`Could not read file "${file.name}".`));
    reader.readAsDataURL(file);
  });
}

export function formatBytes(bytes) {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

// Toggle a value in/out of an array (for multi-select checkboxes)
export function toggleInArray(list, value) {
  if (!Array.isArray(list)) return [value];
  return list.includes(value) ? list.filter((v) => v !== value) : [...list, value];
}

export function todayIsoDate() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

// Build canonical "<TradeName>__<fieldKey>" key for pricing storage
export function pricingKey(trade, fieldKey) {
  return `${trade}__${fieldKey}`;
}
